import { apiFetch } from "./client";
import type { MeResponse } from "./types";

export function fetchMe(signal?: AbortSignal): Promise<MeResponse> {
  return apiFetch<MeResponse>("/Custom/frontend/me", { signal });
}
